import { Grid,Avatar, Typography} from "@material-ui/core";
import {FOOTER_TEXTS,FOOTER_UTILS} from '../../../utility';
import { useLocation } from 'react-router-dom'


function Footer(){
    const location = useLocation();
    return(
        <Grid container xs="12" md="12" direction="row" alignItems="center" justify="center" spacing={1}  style={{position:"sticky",bottom:(location.pathname == "/") ? '1rem' :'0',zIndex:999,backgroundColor: '#F9F9FA',borderTopColor: '#EAEAE9',borderTopStyle: 'solid',backgroundColor:'#F9F9FA'}}>
            <Grid item direction="row" xs="12">
                <a href={FOOTER_UTILS.TOPIC_LOGO_URL_LINK} target="_blank">
                    <Avatar variant="square" src={FOOTER_UTILS.TOPIC_LOGO_LINK} style={{width:85,display:'inline-block',float:'left'}}/>
                    </a>
                <a href={FOOTER_UTILS.HELP_TXT_LINK} target="_blank">
                    <Typography variant="caption" style={{display:'inline-block',margin:"0.5rem",float:'right'}}>{FOOTER_TEXTS.HELP_TXT}</Typography>
                </a>
            </Grid>
        </Grid>
    );

}

export default Footer;